import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pet-passed-away',
  templateUrl: './pet-passed-away.component.html',
  styleUrls: ['./pet-passed-away.component.scss']
})
export class PetPassedAwayComponent implements OnInit {
  @Input() petName: string;
  @Input() currentUserPlan: string;
  @Input() userHasBasicAccount: boolean;
  @Input() isLastPetAlive: boolean;

  isSubscriptionCancellationRequested: boolean = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
